/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MeterUpdate = {
    properties: {
        type: {
            type: 'UtilityTypeEnum',
        },
        meterNumber: {
            type: 'string',
            isNullable: true,
        },
        location: {
            type: 'string',
            isNullable: true,
        },
        isActive: {
            type: 'boolean',
            isNullable: true,
        },
    },
};